import type { ToolActivityEntry } from '../../../src/types';
import { formatRelativeTime, cn } from '@/lib/utils';

/**
 * Activity timeline using the DESIGN.md report palette — warm tonal fills,
 * sharp 4px borders, mono labels. Intended to live inside the inbox's
 * right-side context drawer.
 */
const STATUS_STYLE: Record<ToolActivityEntry['status'], { bg: string; fg: string; border: string }> = {
  running:        { bg: '#eaf4ff', fg: '#0a2b4a', border: '#bcdcff' },
  success:        { bg: '#e6fbec', fg: '#0a3a16', border: '#b8edc6' },
  error:          { bg: '#fde4ea', fg: '#75081f', border: '#f5b7c5' },
  needs_approval: { bg: '#fff0e6', fg: '#7a2a00', border: '#ffd3b3' },
  approved:       { bg: '#e6fbec', fg: '#0a3a16', border: '#b8edc6' },
  rejected:       { bg: '#efece6', fg: '#313130', border: '#dedbd6' },
};

export function AgentActivityTimeline(props: { items: ToolActivityEntry[] }) {
  if (props.items.length === 0) {
    return <p className="text-[11px] text-muted-foreground">No tool calls yet.</p>;
  }
  return (
    <ul className="space-y-1.5">
      {props.items.slice().reverse().map((e) => {
        const s = STATUS_STYLE[e.status];
        return (
          <li
            key={e.id}
            className={cn('rounded-sm border px-2 py-1.5 text-[11px]')}
            style={{ background: s.bg, color: s.fg, borderColor: s.border }}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="font-medium truncate uppercase tracking-mono text-[10px]">
                {e.toolId}
              </span>
              <span className="opacity-70 shrink-0 tabular-nums">
                {formatRelativeTime(e.createdAt)}
              </span>
            </div>
            <div className="mt-0.5 opacity-85 break-words leading-[1.35]">{e.summary}</div>
          </li>
        );
      })}
    </ul>
  );
}
